module.exports = __webpack_public_path__ + "static/img/preview-01.1498d0b1.webp";